import React from 'react';
import { CaretDown, WarningCircle, CalendarBlank, FileX, Bank, Stack } from '@phosphor-icons/react';

const CHIPS = [
  { key: 'open', label: 'Open', icon: Stack, tone: 'bg-[#E8F5F3] text-[#05735F]' },
  { key: 'due_7d', label: 'Due 7d', icon: CalendarBlank, tone: 'bg-amber-50 text-amber-800' },
  { key: 'overdue', label: 'Overdue', icon: WarningCircle, tone: 'bg-rose-50 text-rose-700' },
  { key: 'missing_docs', label: 'Missing docs', icon: FileX, tone: 'bg-orange-50 text-orange-700' },
  { key: 'emd_expiring_30d', label: 'EMD ≤30d', icon: Bank, tone: 'bg-indigo-50 text-indigo-700' },
];

const inrShort = (v) => {
  const n = Number(v || 0);
  if (n >= 1e7) return `₹${(n / 1e7).toFixed(2)} Cr`;
  if (n >= 1e5) return `₹${(n / 1e5).toFixed(1)} L`;
  return `₹${n.toLocaleString('en-IN')}`;
};

export const WorkloadCard = ({ bucket, active, onToggle, index }) => {
  const slug = bucket.te_id || 'unassigned';
  const hot = bucket.overdue > 0;
  return (
    <button
      onClick={onToggle}
      className={`text-left medical-card p-4 transition-[transform,box-shadow,border-color] duration-200 hover:-translate-y-0.5 hover:shadow-lg border-2 ${
        active ? 'border-[#00a69c]' : hot ? 'border-rose-200' : 'border-transparent'
      } ${bucket.te_id ? '' : 'bg-[#FAFAF7]'}`}
      style={{ animation: `fadeUp .35s ease ${index * 60}ms both` }}
      data-testid={`workload-card-${slug}`}
    >
      <div className="flex items-start justify-between gap-2 mb-3">
        <div className="min-w-0">
          <div className="font-semibold text-[#052A23] truncate" style={{ fontFamily: 'Outfit' }}>{bucket.name}</div>
          <div className="text-[11px] text-[#6D8E87] truncate">
            {bucket.te_id ? (bucket.region || 'All regions') : 'No owner assigned'} · pipeline {inrShort(bucket.pipeline_value)}
          </div>
        </div>
        <CaretDown size={14} className={`text-[#6D8E87] mt-1 shrink-0 transition-transform ${active ? 'rotate-180' : ''}`} />
      </div>
      <div className="flex flex-wrap gap-1.5">
        {CHIPS.map(({ key, label, icon: Icon, tone }) => (
          <span
            key={key}
            className={`inline-flex items-center gap-1 text-[11px] font-semibold px-2 py-1 rounded-full ${bucket[key] ? tone : 'bg-slate-50 text-slate-400'}`}
            data-testid={`workload-chip-${slug}-${key}`}
          >
            <Icon size={11} weight="bold" /> {bucket[key]} <span className="font-normal">{label}</span>
          </span>
        ))}
      </div>
    </button>
  );
};
